<template>
  <!-- EDIT STAFF -->
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="editStaffModal"
      persistent
      max-width="900px"
    >
      <v-card>
        <form
          action=""
          @submit.prevent="submitForm"
        >
          <v-card-title>
            <v-flex
              xs11
              sm11
              md11
            ><span class="headline">{{ $t('user.updateStaffTitle') }}</span></v-flex>
            <v-flex
              xs1
              sm1
              md1
            >
              <v-btn
                flat
                @click="closeEditStaffModal(), $validator.reset()"
                class="close"
              ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-alert
              type="success"
              :value="checkAlert"
            >
              {{ $t('user.staffUpdatedSuccessfully') }}
            </v-alert>
            <v-alert
              type="error"
              :value="validationError"
            >
              {{ emailError }}
            </v-alert>
            <v-alert
              type="error"
              :value="phoneValidation"
            >
              <h4>{{ phoneError }}</h4>
            </v-alert>
            <v-alert
              type="error"
              :value="backendError"
            >
              {{ $t('shippingPrices.pleaseUpdateAnythingError') }}
            </v-alert>
            <v-layout wrap>
              <v-flex
                xs12
                class="px-2"
              >
                <v-text-field
                  :label="$t('user.fullName')"
                  v-model="editStaffData.full_name"
                  :error-messages="errors.collect('Full Name')"
                  v-validate="'required'"
                  data-vv-name="Full Name"
                >
                </v-text-field>
              </v-flex>

              <v-flex
                xs12
                md6
                class="px-2"
              >
                <v-text-field
                  :label="$t('columns.email')"
                  v-model="editStaffData.email"
                  :error-messages="errors.collect('email')"
                  v-validate="'required|email'"
                  data-vv-name="email"
                >
                </v-text-field>
              </v-flex>

              <v-flex
                xs12
                md6
                class="px-2"
              >
                <v-text-field
                  :label="$t('columns.phoneNumber')"
                  v-model="editStaffData.phone_number"
                  :error-messages="phoneFieldErrors"
                >
                </v-text-field>
              </v-flex>

              <v-flex
                xs12
                md6
                class="px-2"
              >
                <v-text-field
                  :label="$t('columns.address')"
                  v-model="editStaffData.address"
                >
                </v-text-field>
              </v-flex>

              <!-- <v-flex
                xs12
                md6
                class="px-2"
              >
                <v-select
                  :items="branches"
                  item-value="value"
                  v-model="editStaffData.default_branch_id_fk"
                  :error-messages="errors.collect('Default Branch')"
                  data-vv-name="Default Branch"
                  label="Default Branch*"
                  v-validate="'required'"
                >
                </v-select>
              </v-flex> -->

              <v-flex
                xs12
                md6
                class="px-2"
              >
                <v-select
                  :items="roles"
                  item-value="value"
                  v-model="editStaffData.rolesId"
                  :error-messages="errors.collect('roles')"
                  data-vv-name="roles"
                  :label="$t('columns.role') + '*'"
                  v-validate="'required'"
                  multiple
                  chips
                  deletable-chips
                  autocomplete
                >
                </v-select>
              </v-flex>

              <v-flex
                xs12
                md6
                class="px-2"
              >
                <v-select
                  :items="warehouses"
                  v-model="editStaffData.warehouse_id_fk"
                  :error-messages="errors.collect('Warehouse')"
                  data-vv-name="Warehouse"
                  :label="$t('columns.warehouse') + '*'"
                  v-validate="'required'"
                  multiple
                  chips
                  deletable-chips
                >
                </v-select>
              </v-flex>

              <!-- <v-flex
                xs12
                class="px-2"
              >
                <v-select
                  :items="branches"
                  item-value="value"
                  v-model="editStaffData.branchesId"
                  :error-messages="errors.collect('Branch')"
                  data-vv-name="Branch"
                  label="Branch*"
                  v-validate="'required'"
                  multiple
                  chips
                  deletable-chips
                >
                </v-select>
              </v-flex> -->
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              style="height:auto"
              @click="closeEditStaffModal(), $validator.reset()"
              outline
              color="normal"
            >{{ $t('common.cancel') }}</v-btn>
            <v-btn
              type="submit"
              style="height:auto" class="rtl-mr-2-5pct"
              outline
              color="success"
            >{{ $t('common.update') }}</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </v-layout>
  <!-- /EDIT STAFF -->
</template>

<script>
export default {
  props: [
    'editStaff',
    'roles',
    'warehouses',
    'branches',
    'editStaffData',
    'editStaffModal',
    'checkAlert',
    'closeEditStaffModal',
    'emailError',
    'validationError',
    'backendError',
    'phoneValidation',
    'phoneError'
  ],

  computed: {
    phoneFieldErrors() {
      let phone = this.editStaffData.phone_number
      if (phone && phone.trim() !== '' && !phone.trim().startsWith('+964')) {
        return [this.$t('user.phoneMustStartWith964Error')]
      }
      return []
    }
  },

  methods: {
    submitForm(event) {
      this.$validator.validateAll().then(res => {
        if (res) {
          if (this.phoneFieldErrors.length > 0) return
          this.editStaff()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/user/editStaff.vue